import LoginAction from './LoginActionTypes';
import { LOGOUT_REDIRECT } from '../../../config/envVariables';

export const LogOutAction = () => ({
  type: LoginAction.Log.Out,
});

export const ShowLoginScreen = (reason: string) => {
  window.location.replace(`${LOGOUT_REDIRECT}/close`);
  // tslint:enable: no-expression-statement | no-if-statement | no-object-mutation
};

export const HideLoginScreen = () => {};
